import theme from "@/layouts/themes/defaultTheme";
import { Switch, SwitchProps, styled, useColorScheme } from "@mui/material";

interface MuiSwitchAddPropType {
    isInnerText?: boolean
}

export default function MuiSwitch({ isInnerText, ...props }: SwitchProps & MuiSwitchAddPropType) {
    const { mode } = useColorScheme()
    return (
        <Switch {...props}
            sx={{
                padding: '8px',
                "& .MuiSwitch-track": {
                    borderRadius: '11px',
                    "&::before, &::after": {
                        content: '""',
                        position: "absolute",
                        top: "50%",
                        transform: "translateY(-50%)",
                        width: '16px',
                        height: '16px',
                    },
                    "&::before": {
                        content: !!isInnerText? "'on'" : "''",
                        left: '13.5px',
                        top: '18px',
                        color: mode === 'light' ? 'white !important' : 'black !important',
                        fontWeight: 'bold'
                    },
                    "&::after": {
                        content: !!isInnerText ? "'off'" : "''",
                        right: '11.5px',
                        color: mode === 'light' ? 'white !important' : 'black !important',
                        top: '18px',
                        fontWeight: 'bold'
                    },
                    fontSize: 11
                },
                "& .MuiSwitch-thumb": {
                    boxShadow: "none",
                    width: '18px',
                    height: '18px',
                    margin: '1px',
                },
            }}
        />
    )
}

